'use client';

/**
 * Providers wrapper — stack provider context globali.
 *
 * Estratto da ClientLayout per coprire ANCHE slot @modal del root layout,
 * non solo {children}. Necessario per intercepting routes che usano
 * useAuth/useMaintenance/useLocale/etc. dentro modal portal.
 */

import React from 'react';
import { AuthProvider, MaintenanceProvider } from '@/app/providers';
import { AdminThemeProvider } from '@/components/admin/AdminThemeContext';
import DesignVariantsProvider from '@/components/design/DesignVariantsProvider';
import { ToastProvider } from '@/components/ui/Toast';
import LocaleProvider from '@/components/LocaleProvider';
import UtmCapture from '@/components/analytics/UtmCapture';
import PageContentProvider from '@/components/visual-editing/PageContentProvider';

interface Props {
  children: React.ReactNode;
}

export default function Providers({ children }: Props) {
  return (
    <LocaleProvider>
      <ToastProvider>
        <AuthProvider>
          <AdminThemeProvider>
            <MaintenanceProvider>
              <DesignVariantsProvider>
                <UtmCapture />
                <PageContentProvider>
                  {children}
                </PageContentProvider>
              </DesignVariantsProvider>
            </MaintenanceProvider>
          </AdminThemeProvider>
        </AuthProvider>
      </ToastProvider>
    </LocaleProvider>
  );
}
